import React, {useState, useEffect} from 'react';
import axios from 'axios';
import ChartistTooltip from "chartist-plugin-tooltips-updated";
import ChartistGraph from "react-chartist";
import {
  Button,
  Card ,
  Col,
  Form,
  Row,
} from 'react-bootstrap';
import {useLocalStorage} from 'react-use';

const COLOR = {
  0: `text-success`,
  1: `text-danger`
};

const BAR_COLOR = {
  0: `stroke-success`,
  1: `stroke-danger`,
}

export default function Percentage() {

  const [auth] = useLocalStorage('authenticated');
  const [params, setParams] = useState({});

  const [scopes, setScopes] = useState([]);
  const [instruments, setInstruments] = useState([]);
  const [years, setYears] = useState([]);
  const [report, setReport] = useState(null);

  const fetchReport = async () => {

    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}report/auditee`,
      {
        headers: {Authorization: `Bearer ${auth.token}`},
        params: params,
      }
    );

    setReport(response.data);
  }

  const fetchScopes = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}scopes`,
      {
        headers: {Authorization: `Bearer ${auth.token}`},
        params: {all: true},
      }
    );

    setScopes(response.data.items);
  }

  const fetchInstruments = async () => {

    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}instruments`,
      {
        headers: {Authorization: `Bearer ${auth.token}`},
        params: {
          SCOPE_ID: params.SCOPE_ID,
          all: true
        },
      }
    );

    setInstruments(response.data.items);
  }

  const fetchYears = async () => {

    const response = await axios.get(
      `${process.env.REACT_APP_API_HOST}schedules`,
      {
        headers: {Authorization: `Bearer ${auth.token}`},
        params: {
          INSTRUMENT_ID: params.INSTRUMENT_ID,
          expand: `year`,
          fields: `year`,
          all: `true`
        },
      }
    );

    setYears([...new Set(response.data.items.map(item => item.year))]);
  }

  useEffect(() => {
    fetchScopes();
  }, []);

  useEffect(() => {
    if (params?.SCOPE_ID) {
      fetchInstruments();
    }
  }, [params?.SCOPE_ID]);

  useEffect(() => {
    if (params?.INSTRUMENT_ID)  {
      fetchYears();
    }
  }, [params?.INSTRUMENT_ID]);

  return (
    <Card>
      <Card.Header style={{ align: 'center', }}>
        <Card.Title as="h4">Grafik Pencapaian Program Studi Terhadap Standar (%)</Card.Title>
        <div className="legend">
          {report && report.legends.map((legend, key) => (
            <span key={key}>
              <i className={`fas fa-circle mr-1 ${COLOR[key]}`}></i>
              {legend}{" "}
            </span>
          ))}
        </div>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col>
            <Form.Group>
              <Form.Label>Scopes</Form.Label>
              <Form.Control
                defaultValue={3}
                as="select"
                value={params.SCOPE_ID || ``}
                onChange={({target:{value}}) => setParams({...params, SCOPE_ID: value})}
              >
                <option value={``}>-- Please select scope --</option>
                {scopes && scopes.map((scope, key) => (
                  <option key={key} value={scope.SCOPE_ID}>{scope.SCOPE_NAME}</option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
          <Col>
              <Form.Group>
                <Form.Label>Instruments</Form.Label>
                <Form.Control
                  as="select"
                  value={params.INSTRUMENT_ID || ``}
                  onChange={({target:{value}}) => setParams({...params, INSTRUMENT_ID: value})}
                >
                  <option value={``}>-- Please select instrument --</option>
                  {instruments && instruments.map((instrument, key) => (
                    <option key={key} value={instrument.INSTRUMENT_ID}>{instrument.INSTRUMENT_NAME}</option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Years</Form.Label>
                <Form.Control
                  as="select"
                  value={params.YEAR || ``}
                  onChange={({target:{value}}) => setParams({...params, YEAR: value})}
                >
                  <option value={``}>-- All year --</option>
                  {years && years.map((year, key) => (
                    <option key={key} value={year}>{year}</option>
                  ))}
                </Form.Control>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Action.</Form.Label>
                <Form.Control
                  onClick={fetchReport}
                  as="button"
                  className="btn btn-primary"
                >
                  Generate
                </Form.Control>
              </Form.Group>
            </Col>
        </Row>
        <Row>
          <Col>
            {report && (
              <ChartistGraph
                data={{
                  labels: report.labels,
                  series: report.series.map((value, index) => {
                    return {
                      meta: `${report.labels[index]}: `,
                      value: value,
                      className: BAR_COLOR[index],
                    }
                  }),
                }}
                type="Bar"
                options={{
                  seriesBarDistance: 10,
                  axisX: {
                    showGrid: false,
                  },
                  stackBars: true,
                  height: "500px",
                  plugins: [
                    ChartistTooltip({
                      appendToBody: true
                    })
                  ]
                }}
                responsiveOptions={[
                  [
                    "screen and (max-width: 640px)",
                    {
                      seriesBarDistance: 5,
                      axisX: {
                        labelInterpolationFnc: function (value) {
                          return value[0];
                        },
                      },
                    },
                  ],
                ]}
              />
            )}
          </Col>
        </Row>
      </Card.Body>
      <Card.Footer></Card.Footer>
    </Card>
  );
}